module.exports = __webpack_public_path__ + "static/Corporate_Responsibility_05-f672ff77167cebb075b45fa013345be5.jpg";